import { useEffect, useState } from "react";
import { admin } from "../../lib/api";
import { panel, PageHead } from "../ui";

export default function Newsletter() {
  const [list, setList] = useState([]);
  useEffect(() => { admin.get("/admin/subscribers").then((r) => setList(r.data)); }, []);
  return (
    <div>
      <PageHead title="Newsletter" />
      <p className="text-sm text-zinc-500 mb-4">{list.length} subscribers</p>
      <div className={`${panel} overflow-x-auto`}>
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[11px] uppercase tracking-widest text-zinc-500 border-b border-zinc-800">
            <th className="p-3">Email</th><th className="p-3">Source</th><th className="p-3">Status</th><th className="p-3">Joined</th>
          </tr></thead>
          <tbody>
            {list.map((s) => (
              <tr key={s.id} className="border-b border-zinc-900">
                <td className="p-3 text-zinc-100">{s.email}</td>
                <td className="p-3 text-zinc-500">{s.source}</td>
                <td className="p-3 text-zinc-400">{s.status}</td>
                <td className="p-3 text-zinc-500">{(s.created_at || "").slice(0, 10)}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-zinc-500">No subscribers yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
